/**
 * Adresa pozei unui om (`users_info.Poza`): capatul v4 autentificat
 * `GET /api/v2/hr/photos/{name}` (si `/small`, miniatura), servit din
 * directorul de date al API-ului - vezi `App\Hr\Photos\HrPhotos`.
 *
 * Pana pe 5 noiembrie 2026 ecranele cereau `/application/views/hr/files/poza/`,
 * pe care `application/.htaccess` il refuza (403): pozele nu se vedeau deloc.
 *
 * Numele se codeaza, ca un `/` sau `?` din baza sa nu schimbe adresa; un nume
 * gol da '' - ecranul pune atunci poza implicita.
 */
export const HR_PHOTOS_URL = '/api/v2/hr/photos'

export function hrPhotoUrl(name: string, small = false): string {
  const clean = name.trim()
  if (clean === '') return ''
  return `${HR_PHOTOS_URL}/${encodeURIComponent(clean)}${small ? '/small' : ''}`
}
